import NextLink from 'next/link';
import styled from 'styled-components';

import { ButtonCSS } from './SharedButton';

import type { LinkButtonProps } from './SharedButton';

const SLinkButton = styled.a<LinkButtonProps>`
  ${ButtonCSS}
`;
/**
 * Anchor tags that look like our buttons.
 */
const ButtonLink = ({
  size = 'SMALL',
  ofType = 'PRIMARY',
  href,
  icon,
  children,
  disabled = false,
  onClick,
  className,
  ...rest
}: LinkButtonProps) => {
  const commonProps = {
    size,
    ofType,
    disabled,
    className: `${className ?? ''} ${disabled ? 'is-disabled' : ''}`,
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (disabled) {
        event.preventDefault();
      } else {
        onClick && onClick(event);
      }
    },
    hasIconAndText: Boolean(icon !== undefined && children !== undefined),
    ...rest,
  };

  if (href) {
    return (
      <NextLink href={href} passHref legacyBehavior>
        <SLinkButton {...commonProps} as="a">
          {icon}
          {children}
        </SLinkButton>
      </NextLink>
    );
  }
  return (
    <SLinkButton {...commonProps}>
      {icon}
      {children}
    </SLinkButton>
  );
};

export { ButtonLink };
